import { api, CASES_LIST_TAG } from '@/api';
import { setCasesList, type RootState } from '@/store';
import { handleQueryLifecycle } from '@/api/utils';

export interface DeleteCaseRequest {
  matterId: string;
}

export interface DeleteCaseResponse {
  success: boolean;
}

const deleteCaseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteCase: builder.mutation<DeleteCaseResponse, DeleteCaseRequest>({
      query: ({ matterId }) => ({
        url: 'matter/delete',
        method: 'POST',
        body: {
          matterId,
        },
      }),
      invalidatesTags: () => [{ type: CASES_LIST_TAG }],
      async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        await handleQueryLifecycle(queryFulfilled, () => {
          const state = getState() as RootState;
          const updatedCases = state.cases.casesList.filter((caseItem) => caseItem.matterId !== arg.matterId);
          dispatch(setCasesList(updatedCases));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useDeleteCaseMutation } = deleteCaseApi;
